import React, { Component } from 'react'
import { connect } from 'react-redux'
import commonAction from '../../actions/common'
import cookies from '../../libs/util.cookies'
import './index.scss'

/**
 * 老板看板（微信端原程序内置页面）
 * 财务接口 /financial/* 需要 appCode=YHGHT（axios 默认 WYPT 会被拒绝），
 * 因此走原生 fetch + Authorization: Bearer <we-chat-1.0.0-token>，复用微信端登录态。
 */
const BASE = '/KYWB'
const APP_CODE = 'YHGHT'

function getToken() {
  try {
    return cookies.get('token') || ''
  } catch (e) {
    return ''
  }
}

/** 金额转万元显示：负数 / NaN 保护 */
function toWan(n) {
  const v = Number(n)
  if (n == null || isNaN(v) || !isFinite(v)) return '0.0'
  return (v / 10000).toFixed(1)
}

/** 数值保护：返回 0 或有限数字 */
function toNum(n) {
  const v = Number(n)
  if (n == null || isNaN(v) || !isFinite(v)) return 0
  return v
}

class BossDashboard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      updating: false,
      error: '',
      data: {},
    }
  }

  componentDidMount() {
    if (this.props.path) {
      try {
        this.props.dispatch({ type: commonAction.setPathname, pathname: this.props.path })
      } catch (e) {}
    }
    this.load()
  }

  load = () => {
    this.setState({ updating: true, error: '' })
    const h = { 'Content-Type': 'application/json', 'appCode': APP_CODE }
    const tk = getToken()
    if (tk) h['Authorization'] = 'Bearer ' + tk
    fetch(BASE + '/financial/contract/maintain/bossDashboard', {
      method: 'GET',
      headers: h,
    })
      .then(r => r.json())
      .then(res => {
        if (res && res.code === 200) {
          this.setState({ loading: false, updating: false, data: res.data || {} })
        } else {
          this.setState({ loading: false, updating: false, error: (res && res.message) || '加载失败，请稍后重试' })
        }
      })
      .catch(() => this.setState({ loading: false, updating: false, error: '网络异常，请稍后重试' }))
  }

  render() {
    const { loading, updating, error, data } = this.state
    const plan = toNum(data.todayPlan)
    const done = toNum(data.todayDone)
    const rate = toNum(data.todayRate)
    const ratePct = Math.max(0, Math.min(100, rate))

    return (
      <div className="bd-page">
        <div className="bd-top">
          <div className="bd-title">老板看板</div>
          <button className="bd-refresh" onClick={this.load} disabled={updating}>
            {updating ? '刷新中…' : '更新'}
          </button>
        </div>
        <div className="bd-sub">在保台数 · 应收逾期 · 到期合同 · 今日完成率</div>

        {loading ? (
          <div className="bd-empty">加载中...</div>
        ) : error ? (
          <div className="bd-empty">{error}</div>
        ) : (
          <div>
            <div className="bd-grid">
              <div className="bd-card">
                <div className="bd-num">{data.liftCount || 0}<small>台</small></div>
                <div className="bd-lbl">在保台数</div>
              </div>
              <div className="bd-card">
                <div className="bd-num bd-red">{toWan(data.receivableAmount)}<small>万元</small></div>
                <div className="bd-lbl">应收余额</div>
              </div>
              <div className="bd-card">
                <div className="bd-num bd-deep">{toWan(data.overdueAmount)}<small>万元</small></div>
                <div className="bd-lbl">逾期金额</div>
              </div>
              <div className="bd-card">
                <div className="bd-num bd-orange">{data.expireCount30 || 0}<small>份</small></div>
                <div className="bd-lbl">30天内到期合同</div>
              </div>
              <div className="bd-card bd-wide">
                <div className="bd-num">{rate.toFixed(1)}<small>%</small></div>
                <div className="bd-lbl">今日保养完成率</div>
                <div className="bd-bar">
                  <div className="bd-bar-in" style={{ width: ratePct + '%' }} />
                </div>
                <div className="bd-sub2">计划 {plan} 台 / 已完成 {done} 台</div>
              </div>
            </div>

            {data.overdueRank && data.overdueRank.length > 0 && (
              <div className="bd-block">
                <div className="bd-block-title">⚠️ 逾期应收排行榜 <small>谁欠的钱最多、拖最久</small></div>
                {data.overdueRank.map((o, i) => (
                  <div className="bd-row" key={i}>
                    <span className="bd-rk">{i + 1}</span>
                    <div className="bd-row-main">
                      <div className="bd-row-nm">{o.propertyUnitName} <small>({o.contractNumber})</small></div>
                      <div className="bd-row-sub">逾期 {toNum(o.overdueDays)} 天</div>
                    </div>
                    <div className="bd-row-amt bd-deep">{toWan(o.overdueAmount)}<small>万</small></div>
                  </div>
                ))}
              </div>
            )}

            {data.expireList && data.expireList.length > 0 && (
              <div className="bd-block">
                <div className="bd-block-title">📅 到期合同预警（30天内） <small>再不续约要丢饭碗</small></div>
                {data.expireList.map((e, i) => (
                  <div className="bd-row" key={i}>
                    <div className="bd-row-main">
                      <div className="bd-row-nm">{e.propertyUnitName} <small>({e.contractNumber})</small></div>
                      <div className="bd-row-sub">
                        到期 {String(e.endTime || '').substr(0, 10)} ｜ {e.liftNum || 0} 台 ｜ {e.assignUserName || '未指派'}
                      </div>
                    </div>
                    <div className="bd-row-amt bd-orange">{toWan(e.contractAmount)}<small>万</small></div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    pathname: state.commonR && state.commonR.pathname,
  }
}

export default connect(mapStateToProps)(BossDashboard)